export default __webpack_public_path__ + "static/media/737.c4a2b71f.png";